<script lang="ts">
    let {
        number
    }: {
        number: number;
    } = $props();

    let formattedNumber: string = $state('');

    $effect(() => {
        formattedNumber = number.toLocaleString('nl-NL');
    });
</script>

{formattedNumber}
